import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../../contexts/ThemeContext';
import GenericListWidget from './GenericListWidget';
import { useSpareDeliveries, type SpareDelivery } from '../../spares/spare-deliveries/useData';
import { formatDate } from '../../../config/appConfig';

const SparesRecentDeliveries: React.FC<{ limit?: number; embedded?: boolean; settings?: Record<string, unknown> }> = ({
  limit = 5,
  embedded,
  settings,
}) => {
  const navigate = useNavigate();
  const { colors } = useTheme();
  const effectiveLimit = typeof settings?.limit === 'number' ? settings.limit : limit;
  const { data, isLoading } = useSpareDeliveries(undefined, 1, 50);

  const items = [...(data ?? [])]
    .sort((a, b) => new Date(b.dlvDate || b.createdAt).getTime() - new Date(a.dlvDate || a.createdAt).getTime())
    .slice(0, effectiveLimit);

  return (
    <GenericListWidget<SpareDelivery>
      title="Spares · Recent Deliveries"
      viewAllPath="/spares/spare-deliveries"
      data={items}
      isLoading={isLoading}
      limit={effectiveLimit}
      emptyMessage="No deliveries"
      getItemKey={(d) => d.id}
      embedded={embedded}
      renderItem={(delivery) => (
        <div
          onClick={() => navigate(`/spares/spare-deliveries/${delivery.id}`)}
          className="flex items-center justify-between gap-3 p-2 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800/40 cursor-pointer"
        >
          <div className="min-w-0">
            <p className={`text-sm font-medium truncate ${colors.text}`}>{delivery.ref || `Delivery #${delivery.id}`}</p>
            <p className={`text-xs ${colors.textMuted}`}>
              {delivery.spareCase?.ref || 'No case'} {delivery.vessel?.vesselName ? `· ${delivery.vessel.vesselName}` : ''}
            </p>
          </div>
          <span className={`text-xs whitespace-nowrap ${colors.textMuted}`}>{formatDate(delivery.dlvDate || delivery.createdAt)}</span>
        </div>
      )}
    />
  );
};

export default SparesRecentDeliveries;
